import { render, staticRenderFns } from "./_lecture.vue?vue&type=template&id=fe4aba2c&"
import script from "./_lecture.vue?vue&type=script&lang=js&"
export * from "./_lecture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionDetailPricing: require('/home/smiley/3df/components/Section/SectionDetailPricing/SectionDetailPricing.vue').default,ConstructorLayout: require('/home/smiley/3df/components/Constructor/ConstructorLayout.vue').default,CardProfile: require('/home/smiley/3df/components/Card/CardProfile/CardProfile.vue').default,ConstructorTrainerDetails: require('/home/smiley/3df/components/Constructor/ConstructorTrainerDetails.vue').default,CardTestimonial: require('/home/smiley/3df/components/Card/CardTestimonial/CardTestimonial.vue').default,CardSmall: require('/home/smiley/3df/components/Card/CardSmall/CardSmall.vue').default,AcademySectionRegister: require('/home/smiley/3df/components/AcademySectionRegister/AcademySectionRegister.vue').default})
